<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span
      class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide"
    >Type:</span>
    <div class="wf-w-1/2">
      <select v-model="separatorType" class="wf-w-full">
        <option
          :key="typeOption.value"
          v-for="typeOption in typeOptions"
          :value="typeOption.value"
          v-text="typeOption.text"
        ></option>
      </select>
    </div>
  </li>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      typeOptions() {
        return [
          {value: 'none', text: 'None'},
          {value: 'icon', text: 'With Icon'},
          {value: 'text', text: 'With Text'},
        ]
      },
      separatorType: {
        get() {
          let elementContent = 'none';
          if (this.elementContent.hasIcon) elementContent = 'icon';
          if (this.elementContent.hasText) elementContent = 'text';
          return elementContent
        },
        set(value) {
          let contentEl = {hasIcon: false, hasText: false}
          if (value === 'icon') contentEl = {hasIcon: true, hasText: false}
          if (value === 'text') contentEl = {hasIcon: false, hasText: true}
          this.addToObject(this.module, contentEl, 'content', null, {}, true, this.parentModule)
        }
      },
    }
  })
</script>
